import React from 'react';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

const faqConfig = {
    settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: '/faq',
            component: React.lazy(() => import('./faq'))
        },
        {
            path: '/:subSystem/faq',
            component: () => <Redirect to={'/faq'} />
        }
        
    ]
};

export default faqConfig;